import React from 'react'
import Errors from '../errors'

const ErrorsEn = () => {
    return <Errors languageCode="en" />
}

export default ErrorsEn
